import { useQuery } from '@tanstack/react-query';
import { fetchLookupProductForms } from '../services/lookupService';
import { ISelectOption } from '@common/types';
import { ILookupDto } from '@common/features/submission/types';

export const queryKey = 'fetchProductForms';

export const useFetchProductForms = (search: string | null = null, limit?: number) => {
  const { data, isFetching, isFetched } = useQuery([queryKey], 
    () => fetchLookupProductForms(search, limit), {
      select: (data) =>
        data?.map((x: { name: string; snomedCode: string }) => ({
          label: x.name,
          value: x.snomedCode,
        })) as ISelectOption[],
      staleTime: Infinity,
    });

  return {
    productForms: data,
    isFetching,
    isFetched,
  };
};

export const useFetchProductFormsAsILookupDto = (search: string | null = null, limit?: number) => {
  const { data, isFetching, isFetched } = useQuery([queryKey, search],
      () => fetchLookupProductForms(search, limit), {
      select: (data) =>
        data?.map((x: { Id: string; name: string }) => ({
          id: x.Id,
          name: x.name,
        })) as ILookupDto[],
      staleTime: Infinity,
      enabled: search ? search.trim().length >= 3 : false,
    });

  return {
    productForms: search && search.trim().length >= 3 && !!data ? data : new Array<ILookupDto>(),
    isFetching,
    isFetched,
  };
};
